const doc = [({"en":({"js":({"admin":({"subscription_periods":({"table":({"the_period_was_deleted":"The period was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;